import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import PublicLayout from "../layouts/PublicLayout";

import HomePage from "../pages/home/HomePage";
import SignIn from "../pages/signin/SignIn";
import SignUp from "../pages/signup/SignUp";

import RoleProtectedRoute from './RoleProtectedRoute'
import CssBaseline from '@mui/material/CssBaseline';
import DashboardLayout from '../app/components/DashboardLayout';
import EmployeeList from '../app/components/JobList';
import EmployeeShow from '../app/components/JobShow';
import EmployeeCreate from '../app/components/JobCreate';
import EmployeeEdit from '../app/components/JobEdit';
import NotificationsProvider from '../app/hooks/useNotifications/NotificationsProvider';
import DialogsProvider from '../app/hooks/useDialogs/DialogsProvider';
import AppTheme from '../shared-theme/AppTheme';
import {
  dataGridCustomizations,
  datePickersCustomizations,
  sidebarCustomizations,
  formInputCustomizations,
} from '../app/theme/customizations';
import Unauthorized from "../pages/Unauthorized";
import DashboardHome from "../app/components/DashBoardHome";
import ResumePage from "../app/components/ResumePage";
import ResumeUploadPage from "../app/components/ResumeUploadPage";
import MyApplications from "../app/components/MyApplications";
import JobsPage from "../app/components/JobsPage";
import JobApplications from "../app/components/JobApplications";
import ShortlistedResumesPage from "../app/components/ShortlistedResumesPage";
import ShortlistJobPage from "../app/components/ShortlistJobPage";
import ProfilePage from "../app/components/ProfilePage";


const themeComponents = {
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...sidebarCustomizations,
  ...formInputCustomizations,
};


export default function AppRoutes(props) {
  return (
    <Routes>
      {/* Public routes inside PublicLayout */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
      </Route>

      {/* Unauthorized */}
      

      {/* Protected routes inside SecureLayout */}
      <Route
        element={
          <ProtectedRoute />
        }
      />

      {/* Protected: App (wrap only /app with AppTheme + providers) */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppTheme {...props} themeComponents={themeComponents}>
              <CssBaseline enableColorScheme />
              <NotificationsProvider>
                <DialogsProvider>
                  <DashboardLayout />
                </DialogsProvider>
              </NotificationsProvider>
            </AppTheme>
          </ProtectedRoute>
        }
      >
        {/* Default dashboard page */}
        <Route index element={<DashboardHome />} />
        <Route path="unauthorized" element={<Unauthorized />} />

        {/* HR-only */}
        <Route element={<RoleProtectedRoute allowedRoles={["HR"]} />}>
          <Route path="hr/applications" element={<JobsPage />} />
          <Route path="hr/applications/job/:id/applications" element={<JobApplications />} />
          <Route path="hr/applications/job/:id/applications/shortlist" element={<ShortlistedResumesPage />} />
          <Route path="hr/job/:id/edit" element={<EmployeeEdit />} />
          <Route path="hr/jobs/new" element={<EmployeeCreate />} />
        </Route>

        {/* USER-only */}
        <Route element={<RoleProtectedRoute allowedRoles={["USER"]} />}>
          <Route path="user/resume" element={<ResumePage />} />
          <Route path="user/resume/upload" element={<ResumeUploadPage />} />
          <Route path="user/applications" element={<MyApplications />} />
          <Route path="user/resume/shortlist" element={<ShortlistJobPage />} />
        </Route>

        {/* ADMIN-only */}
        <Route element={<RoleProtectedRoute allowedRoles={["HR","USER"]} />}>
          <Route path="jobs" element={<EmployeeList />} />
          <Route path="job/:id" element={<EmployeeShow />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>
      </Route>


    </Routes>
  );
}
